import { HttpService } from '@/shared/lib/http'

import type { TGetPlantaDoLoteamentoResponse } from '../interfaces/empreendimento.types'

export class GetPlantaDoLoteamentoService extends HttpService {
  execute = async (idExterno: string) => {
    return this.http.get<TGetPlantaDoLoteamentoResponse>(`/api/v2/Empreendimento/${idExterno}/plantaDoLoteamento`)
  }
}
